import { __extends } from "tslib";
var CustomError = /** @class */ (function (_super) {
    __extends(CustomError, _super);
    function CustomError(pMessage) {
        var _this = _super.call(this, pMessage) || this;
        Object.setPrototypeOf(_this, CustomError.prototype);
        return _this;
    }
    Object.defineProperty(CustomError.prototype, "name", {
        //override name property, returns class name as default
        get: function () {
            return (this.mCustomName != null ? this.mCustomName : this.constructor.name);
        },
        set: function (pName) {
            this.mCustomName = pName;
        },
        enumerable: false,
        configurable: true
    });
    return CustomError;
}(Error));
export { CustomError };
export default CustomError;
